/*
 * Файл создан скриптом scripts/build-icons.mjs из assets/icons/*.svg.
 * Руками не править: правка потеряется при следующей сборке. Нужен новый
 * глиф — положите SVG в assets/icons и выполните `pnpm icons`.
 *
 * Иконок: 100.
 */
import type { JSX } from 'react';

export interface Glyph {
  /** Своя система координат: набор собран из сеток 16, 24 и 512. */
  viewBox: string;
  body: JSX.Element;
}

export const GLYPHS = {
  arrowLeft: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <path d="M13 8H3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
          <path
            d="M7 4L3 8L7 12"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  arrowRight: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <path d="M3 8H13" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
          <path
            d="M9 4L13 8L9 12"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  cameraOff: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M1.8 4.6h6.4a1 1 0 0 1 1 1v4.8a1 1 0 0 1-1 1H1.8a1 1 0 0 1-1-1V5.6a1 1 0 0 1 1-1Z" />
          <path d="M9.2 8.3 14.4 5.2v5.6L9.2 7.7" />
          <path d="m1.6 1.6 12.8 12.8" />
        </g>
      </>
    ),
  },
  chartBars: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2.4" y="8.4" width="3" height="5.2" rx="0.6" />
          <rect x="6.5" y="4.6" width="3" height="9" rx="0.6" />
          <rect x="10.6" y="6.8" width="3" height="6.8" rx="0.6" />
        </g>
      </>
    ),
  },
  chartLine: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2.4 11.4 6 7.6 9.2 10.2 13.6 4.8" />
          <path d="M2.4 13.6h11.2" />
        </g>
      </>
    ),
  },
  check: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M15 20V15H9V20M18 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H14.1716C14.702 4 15.2107 4.21071 15.5858 4.58579L19.4142 8.41421C19.7893 8.78929 20 9.29799 20 9.82843V18C20 19.1046 19.1046 20 18 20Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  chevronDown: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M7 10L12 15L17 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  chevronLeft: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M10 3.5 5.5 8l4.5 4.5" />
        </g>
      </>
    ),
  },
  chevronRight: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 3.5 10.5 8 6 12.5" />
        </g>
      </>
    ),
  },
  close: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M19 5L5 19M5.00001 5L19 19"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  copy: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M17.5 14H19C20.1046 14 21 13.1046 21 12V5C21 3.89543 20.1046 3 19 3H12C10.8954 3 10 3.89543 10 5V6.5M5 10H12C13.1046 10 14 10.8954 14 12V19C14 20.1046 13.1046 21 12 21H5C3.89543 21 3 20.1046 3 19V12C3 10.8954 3.89543 10 5 10Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  download: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M20 15V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18L4 15M8 11L12 15M12 15L16 11M12 15V3"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  drive: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <path
            d="M2.5 4.5C2.5 3.94772 2.94772 3.5 3.5 3.5H12.5C13.0523 3.5 13.5 3.94772 13.5 4.5V7.5H2.5V4.5Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
          <path
            d="M2.5 7.5H13.5V11.5C13.5 12.0523 13.0523 12.5 12.5 12.5H3.5C2.94772 12.5 2.5 12.0523 2.5 11.5V7.5Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
          <circle cx="11" cy="10" r="0.9" stroke="currentColor" strokeWidth="1.2" />
        </g>
      </>
    ),
  },
  ellipsis: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <circle cx="3.5" cy="8" r="0.9" stroke="currentColor" strokeWidth="1.2" />
          <circle cx="8" cy="8" r="0.9" stroke="currentColor" strokeWidth="1.2" />
          <circle cx="12.5" cy="8" r="0.9" stroke="currentColor" strokeWidth="1.2" />
        </g>
      </>
    ),
  },
  expand: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M9.00002 3.99997H4.00004L4 8.99999M20 8.99999V4L15 3.99997M15 20H20L20 15M4 15L4 20L9.00002 20"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  eyeOff: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <path
            d="M6.2 3.8C6.77 3.6 7.37 3.5 8 3.5C12 3.5 14.5 8 14.5 8C14.5 8 13.75 9.35 12.4 10.53"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.1 11.9C9.44 12.29 8.74 12.5 8 12.5C4 12.5 1.5 8 1.5 8C1.5 8 2.5 6.2 4.2 4.9"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.6 6.6C6.23 6.97 6 7.46 6 8C6 9.1 6.9 10 8 10C8.54 10 9.03 9.77 9.4 9.4"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.5 2.5L13.5 13.5"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
        </g>
      </>
    ),
  },
  eye: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <path
            d="M1.5 8C1.5 8 4 3.5 8 3.5C12 3.5 14.5 8 14.5 8C14.5 8 12 12.5 8 12.5C4 12.5 1.5 8 1.5 8Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="8" cy="8" r="2" stroke="currentColor" strokeWidth="1.2" />
        </g>
      </>
    ),
  },
  file: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <path
            d="M4 2.5H9L12.5 6V13C12.5 13.2761 12.2761 13.5 12 13.5H4C3.72386 13.5 3.5 13.2761 3.5 13V3C3.5 2.72386 3.72386 2.5 4 2.5Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 2.5V6H12.5"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  filter: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M4 5L10 5M10 5C10 6.10457 10.8954 7 12 7C13.1046 7 14 6.10457 14 5M10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5M14 5L20 5M4 12H16M16 12C16 13.1046 16.8954 14 18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12ZM8 19H20M8 19C8 17.8954 7.10457 17 6 17C4.89543 17 4 17.8954 4 19C4 20.1046 4.89543 21 6 21C7.10457 21 8 20.1046 8 19Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </g>
      </>
    ),
  },
  fitView: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2.6 6V2.6H6M10 2.6h3.4V6M13.4 10v3.4H10M6 13.4H2.6V10" />
        </g>
      </>
    ),
  },
  folderPlus: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <path
            d="M2 4.5C2 3.94772 2.44772 3.5 3 3.5H6L7.5 5.5H13C13.5523 5.5 14 5.94772 14 6.5V12C14 12.5523 13.5523 13 13 13H3C2.44772 13 2 12.5523 2 12V4.5Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M8 8V11" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
          <path d="M6.5 9.5H9.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        </g>
      </>
    ),
  },
  folder: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <path
            d="M2 4.5C2 3.94772 2.44772 3.5 3 3.5H6L7.5 5.5H13C13.5523 5.5 14 5.94772 14 6.5V12C14 12.5523 13.5523 13 13 13H3C2.44772 13 2 12.5523 2 12V4.5Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  forward: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2.6 4.4 6.8 8l-4.2 3.6zM8.6 4.4 12.8 8l-4.2 3.6z" />
        </g>
      </>
    ),
  },
  frame: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M6 3V21"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18 3V21"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 6H21"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 18H21"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  globe: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <circle
            cx="8"
            cy="8"
            r="6"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 8H14"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 2C9.75 3.9 10.6 5.9 10.6 8C10.6 10.1 9.75 12.1 8 14C6.25 12.1 5.4 10.1 5.4 8C5.4 5.9 6.25 3.9 8 2Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  grid: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <circle
            cx="4"
            cy="4"
            r="1"
            transform="rotate(90 4 4)"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <circle
            cx="12"
            cy="4"
            r="1"
            transform="rotate(90 12 4)"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <circle
            cx="20"
            cy="4"
            r="1"
            transform="rotate(90 20 4)"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <circle
            cx="4"
            cy="12"
            r="1"
            transform="rotate(90 4 12)"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <circle
            cx="12"
            cy="12"
            r="1"
            transform="rotate(90 12 12)"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <circle
            cx="20"
            cy="12"
            r="1"
            transform="rotate(90 20 12)"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <circle
            cx="4"
            cy="20"
            r="1"
            transform="rotate(90 4 20)"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <circle
            cx="12"
            cy="20"
            r="1"
            transform="rotate(90 12 20)"
            stroke="currentColor"
            strokeWidth="1.8"
          />
          <circle
            cx="20"
            cy="20"
            r="1"
            transform="rotate(90 20 20)"
            stroke="currentColor"
            strokeWidth="1.8"
          />
        </g>
      </>
    ),
  },
  info: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="8" cy="8" r="5.5" />
          <path d="M8 7.4v3.4" />
          <path d="M8 5.2v.01" />
        </g>
      </>
    ),
  },
  key: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M12.3212 10.6852L4 19L6 21M7 16L9 18M20 7.5C20 9.98528 17.9853 12 15.5 12C13.0147 12 11 9.98528 11 7.5C11 5.01472 13.0147 3 15.5 3C17.9853 3 20 5.01472 20 7.5Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  layerSolo: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <path
            d="M8 2L14 5.5L8 9L2 5.5L8 2Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
          <path
            d="M3.6 7.6L2 8.5L8 12L14 8.5L12.4 7.6"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="1.4 1.6"
          />
        </g>
      </>
    ),
  },
  layers: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <path
            d="M8 2L14 5.5L8 9L2 5.5L8 2Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
          <path
            d="M3.6 7.6L2 8.5L8 12L14 8.5L12.4 7.6"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  layout1x1: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2.5" y="2.5" width="11" height="11" rx="1" />
        </g>
      </>
    ),
  },
  layout2x2: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2.5" y="2.5" width="4.6" height="4.6" rx="0.8" />
          <rect x="8.9" y="2.5" width="4.6" height="4.6" rx="0.8" />
          <rect x="2.5" y="8.9" width="4.6" height="4.6" rx="0.8" />
          <rect x="8.9" y="8.9" width="4.6" height="4.6" rx="0.8" />
        </g>
      </>
    ),
  },
  layout3x3: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2.5" y="2.5" width="11" height="11" rx="1" />
          <path d="M6.17 2.5v11M9.83 2.5v11M2.5 6.17h11M2.5 9.83h11" />
        </g>
      </>
    ),
  },
  layout4x4: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2.5" y="2.5" width="11" height="11" rx="1" />
          <path d="M5.25 2.5v11M8 2.5v11M10.75 2.5v11M2.5 5.25h11M2.5 8h11M2.5 10.75h11" />
        </g>
      </>
    ),
  },
  layoutCustom: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2.5" y="2.5" width="11" height="11" rx="1" />
          <path d="M9.5 2.5v11M9.5 8h4" />
        </g>
      </>
    ),
  },
  levelUp: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <path
            d="M5 6L8 3L11 6"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 3V10C8 11.1046 8.89543 12 10 12H13"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  lock: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M8 11V7C8 5.66667 8.8 3 12 3C15.2 3 16 5.66667 16 7V11M8 11H5V21H19V11H16M8 11H16"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  login: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M15 4H18C19.1046 4 20 4.89543 20 6L20 18C20 19.1046 19.1046 20 18 20H15M11 16L15 12M15 12L11 8M15 12H3"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  logout: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M15 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H15M8 8L4 12M4 12L8 16M4 12L16 12"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  menu: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <path
            d="M2.5 4H13.5M2.5 8H13.5M2.5 12H13.5"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  minimap: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <rect x="2" y="3" width="12" height="10" rx="1" stroke="currentColor" strokeWidth="1.2" />
          <rect
            x="8.5"
            y="8"
            width="4.5"
            height="4"
            rx="0.5"
            stroke="currentColor"
            strokeWidth="1.2"
          />
        </g>
      </>
    ),
  },
  minus: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3.2 8h9.6" />
        </g>
      </>
    ),
  },
  moon: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <path
            d="M14 8.53A6 6 0 1 1 7.47 2A4.67 4.67 0 0 0 14 8.53Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  navAgents: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2.6" y="9" width="10.8" height="4.4" rx="1" />
          <circle cx="5" cy="11.2" r="0.75" fill="currentColor" stroke="none" />
          <path d="M6.2 6.6a2.6 2.6 0 0 1 3.6 0" />
          <path d="M4.4 4.8a5.2 5.2 0 0 1 7.2 0" />
        </g>
      </>
    ),
  },
  navArchive: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2" y="2.8" width="12" height="3.2" rx="0.8" />
          <path d="M3.2 6v6.2c0 .6.4 1 1 1h7.6c.6 0 1-.4 1-1V6" />
          <path d="M6.4 8.8h3.2" />
        </g>
      </>
    ),
  },
  navAudit: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 3.4H4.4c-.6 0-1 .4-1 1v8.6c0 .6.4 1 1 1h7.2c.6 0 1-.4 1-1V4.4c0-.6-.4-1-1-1H10" />
          <rect x="6" y="2" width="4" height="2.8" rx="0.8" />
          <path d="M5.8 8h4.4M5.8 10.6h2.8" />
        </g>
      </>
    ),
  },
  navEvents: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3.9 11.4c1-1 1.5-2 1.5-3.6V7a2.6 2.6 0 0 1 5.2 0v0.8c0 1.6.5 2.6 1.5 3.6Z" />
          <path d="M6.6 11.4v.3a1.4 1.4 0 0 0 2.8 0v-.3" />
        </g>
      </>
    ),
  },
  navMap: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="4" cy="4.5" r="1.9" />
          <circle cx="12" cy="4.5" r="1.9" />
          <circle cx="8" cy="12" r="1.9" />
          <path d="M5.9 4.5h4.2" />
          <path d="M4.8 6.2 7.2 10.4" />
          <path d="M11.2 6.2 8.8 10.4" />
        </g>
      </>
    ),
  },
  navNodes: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2" y="3" width="12" height="10" rx="1.2" />
          <path d="M4.2 8.6h2L7.4 6.2 8.8 10.4 9.8 8.6h2" />
        </g>
      </>
    ),
  },
  navNotifications: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M4 6.6a4 4 0 0 1 8 0c0 2.4.6 3.6 1.2 4.3H2.8C3.4 10.2 4 9 4 6.6Z" />
          <path d="M6.6 13a1.6 1.6 0 0 0 2.8 0" />
        </g>
      </>
    ),
  },
  navOverview: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2.5 11.5a5.5 5.5 0 0 1 11 0" />
          <path d="M8 11.5 11.2 8.1" />
          <path d="M2.5 13.5h11" />
        </g>
      </>
    ),
  },
  navSessions: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2" y="5" width="9" height="8" rx="1.2" />
          <path d="M2 7.6h9" />
          <path d="M5 5V4c0-.6.4-1 1-1h7c.6 0 1 .4 1 1v7c0 .6-.4 1-1 1h-1" />
        </g>
      </>
    ),
  },
  navSites: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2.6 13.4V3.6c0-.6.4-1 1-1h5c.6 0 1 .4 1 1v9.8" />
          <path d="M9.6 6.6h2.8c.6 0 1 .4 1 1v5.8" />
          <path d="M2 13.4h12" />
          <path d="M5 5.4h1.2M5 8h1.2M5 10.6h1.2" />
        </g>
      </>
    ),
  },
  navSsh: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="1.6" y="2.4" width="12.8" height="11.2" rx="1.2" />
          <path d="M1.6 5.2h12.8" />
          <path d="M4.4 8 6.3 9.8 4.4 11.6" />
          <path d="M8 11.6h3.4" />
        </g>
      </>
    ),
  },
  navUsers: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="6.4" cy="5.4" r="2.4" />
          <path d="M2.4 13.4c0-2.2 1.8-3.6 4-3.6s4 1.4 4 3.6" />
          <path d="M10.8 3.5a2.3 2.3 0 0 1 0 4" />
          <path d="M11.4 9.9c1.3.4 2.2 1.6 2.2 3.1" />
        </g>
      </>
    ),
  },
  navVideo: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2" y="3" width="12" height="10" rx="1.2" />
          <path d="M9 3v10" />
          <path d="M9 8h5" />
        </g>
      </>
    ),
  },
  navVnc: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2" y="2.8" width="12" height="10.4" rx="1.2" />
          <path d="M5 6.4 6.9 8.2 5 10" />
          <path d="M8.6 10h2.6" />
        </g>
      </>
    ),
  },
  netdeck: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="currentColor">
          <polygon points="11.19 11.35 15.75 3.51 6.75 3.51 2.25 11.35 11.19 11.35" />
          <polygon points="2.25 12.65 6.74 20.49 15.73 20.49 11.25 12.65 2.25 12.65" />
          <path d="M21.75,12l-4.5-7.87L12.74,12l4.51,7.87Z" />
        </g>
      </>
    ),
  },
  nodeAp: {
    viewBox: '0 0 512 512',
    body: (
      <>
        <g fill="currentColor">
          <g>
            <g>
              <path d="M486.4,290.133h-59.733V55.467c0-7.066-5.726-12.8-12.8-12.8c-7.074,0-12.8,5.734-12.8,12.8v234.667H110.933V55.467 c0-7.066-5.726-12.8-12.8-12.8c-7.074,0-12.8,5.734-12.8,12.8v234.667H25.6c-14.14,0-25.6,11.46-25.6,25.6v128 c0,14.14,11.46,25.6,25.6,25.6h460.8c14.14,0,25.6-11.46,25.6-25.6v-128C512,301.594,500.54,290.133,486.4,290.133z M486.4,443.733H25.6v-128h460.8V443.733z" />
            </g>
          </g>
          <g>
            <g>
              <circle cx="311.467" cy="379.733" r="12.8" />
            </g>
          </g>
          <g>
            <g>
              <circle cx="362.667" cy="379.733" r="12.8" />
            </g>
          </g>
          <g>
            <g>
              <circle cx="413.867" cy="379.733" r="12.8" />
            </g>
          </g>
        </g>
      </>
    ),
  },
  nodeCamera: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="1.5" y="4.5" width="9" height="7" rx="1" />
          <path d="M10.5 7.2 14.5 5v6l-4-2.2z" />
        </g>
      </>
    ),
  },
  nodeCloud: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5.3 7.5A2.2 2.2 0 1 1 5.99 3.21A2.6 2.6 0 0 1 10.8 3.7A1.9 1.9 0 1 1 10.9 7.5Z" />
          <path d="M8 7.5v2" />
          <rect x="2.5" y="9.5" width="11" height="4.5" rx="1" />
          <circle cx="5" cy="11.75" r="0.75" fill="currentColor" stroke="none" />
        </g>
      </>
    ),
  },
  nodeLabel: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M21 18V6H8L2 12L8 18H21Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 12C12 13.1046 11.1046 14 10 14C8.89543 14 8 13.1046 8 12C8 10.8954 8.89543 10 10 10C11.1046 10 12 10.8954 12 12Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  nodeNas: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2.5" y="2.5" width="11" height="11" rx="1" />
          <circle cx="8" cy="6" r="1.7" />
          <circle cx="8" cy="10.4" r="1.7" />
        </g>
      </>
    ),
  },
  nodeNvr: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="1.5" y="4" width="13" height="8" rx="1" />
          <rect x="3.4" y="5.9" width="1.8" height="1.8" fill="currentColor" stroke="none" />
          <rect x="6.2" y="5.9" width="1.8" height="1.8" fill="currentColor" stroke="none" />
          <rect x="3.4" y="8.3" width="1.8" height="1.8" fill="currentColor" stroke="none" />
          <rect x="6.2" y="8.3" width="1.8" height="1.8" fill="currentColor" stroke="none" />
          <path d="M10 6.8h2.5" />
          <path d="M10 9.2h2.5" />
        </g>
      </>
    ),
  },
  nodeOther: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12H3M12 21C7.02944 21 3 16.9706 3 12M12 21C12 21 16 18 16 12C16 6 12 3 12 3M12 21C12 21 8 18 8 12C8 6 12 3 12 3M3 12C3 7.02944 7.02944 3 12 3"
            stroke="currentColor"
            strokeWidth="1.8"
          />
        </g>
      </>
    ),
  },
  nodePc: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="1.5" y="2.5" width="13" height="8.5" rx="1" />
          <path d="M8 11v3" />
          <path d="M5 14h6" />
        </g>
      </>
    ),
  },
  nodePhone: {
    viewBox: '0 0 512 512',
    body: (
      <>
        <g fill="currentColor">
          <g>
            <g>
              <path d="M460.8,25.6H179.2c0-14.14-11.46-25.6-25.6-25.6h-51.2C91.921,0,0,7.185,0,256s91.921,256,102.4,256h51.2 c14.14,0,25.6-11.46,25.6-25.6h281.6c28.279,0,51.2-22.921,51.2-51.2V76.8C512,48.521,489.079,25.6,460.8,25.6z M153.6,486.4 c0,0-25.6,0-51.2,0c-25.6,0-76.8-51.2-76.8-230.4S76.8,25.6,102.4,25.6c25.6,0,51.2,0,51.2,0V128c0,0-20.207,0-42.667,0 c-6.793,0-13.303,2.697-18.099,7.501c-5.53,5.521-33.101,37.308-33.101,120.499s27.571,114.978,33.101,120.499 c4.796,4.804,11.307,7.501,18.099,7.501c22.46,0,42.667,0,42.667,0V486.4z M128,153.6v204.8h-17.067c0,0-25.6-25.6-25.6-102.4 s25.6-102.4,25.6-102.4H128z M486.4,435.2c0,14.114-11.486,25.6-25.6,25.6H179.2V384c0-14.14-11.46-25.6-25.6-25.6V153.6 c14.14,0,25.6-11.46,25.6-25.6V51.2h281.6c14.114,0,25.6,11.486,25.6,25.6V435.2z" />
            </g>
          </g>
          <g>
            <g>
              <rect x="230.4" y="128" width="51.2" height="25.6" />
            </g>
          </g>
          <g>
            <g>
              <rect x="307.2" y="128" width="51.2" height="25.6" />
            </g>
          </g>
          <g>
            <g>
              <rect x="384" y="128" width="51.2" height="25.6" />
            </g>
          </g>
          <g>
            <g>
              <rect x="230.4" y="204.8" width="51.2" height="25.6" />
            </g>
          </g>
          <g>
            <g>
              <rect x="307.2" y="204.8" width="51.2" height="25.6" />
            </g>
          </g>
          <g>
            <g>
              <rect x="384" y="204.8" width="51.2" height="25.6" />
            </g>
          </g>
          <g>
            <g>
              <rect x="230.4" y="281.6" width="51.2" height="25.6" />
            </g>
          </g>
          <g>
            <g>
              <rect x="307.2" y="281.6" width="51.2" height="25.6" />
            </g>
          </g>
          <g>
            <g>
              <rect x="384" y="281.6" width="51.2" height="25.6" />
            </g>
          </g>
          <g>
            <g>
              <rect x="230.4" y="358.4" width="51.2" height="25.6" />
            </g>
          </g>
          <g>
            <g>
              <rect x="307.2" y="358.4" width="51.2" height="25.6" />
            </g>
          </g>
          <g>
            <g>
              <rect x="384" y="358.4" width="51.2" height="25.6" />
            </g>
          </g>
        </g>
      </>
    ),
  },
  nodePrinter: {
    viewBox: '0 0 512 512',
    body: (
      <>
        <g fill="currentColor">
          <g>
            <g>
              <rect x="162.133" y="435.2" width="179.2" height="25.6" />
            </g>
          </g>
          <g>
            <g>
              <rect x="162.133" y="384" width="179.2" height="25.6" />
            </g>
          </g>
          <g>
            <g>
              <rect x="162.133" y="332.8" width="179.2" height="25.6" />
            </g>
          </g>
          <g>
            <g>
              <path d="M460.8,128h-68.267V0h-281.6v128H51.2C22.972,128,0,150.972,0,179.2v179.2c0,28.228,22.972,51.2,51.2,51.2h59.733V512 h281.6V409.6H460.8c28.237,0,51.2-22.972,51.2-51.2V179.2C512,150.972,489.037,128,460.8,128z M136.533,25.6h230.4V128h-230.4 V25.6z M366.933,486.4h-230.4V281.6h230.4V486.4z M486.4,358.4c0,14.14-11.46,25.6-25.6,25.6h-68.267V281.6H422.4 c7.074,0,12.8-5.726,12.8-12.8c0-7.074-5.726-12.8-12.8-12.8H89.6c-7.074,0-12.8,5.726-12.8,12.8c0,7.074,5.726,12.8,12.8,12.8 h21.333V384H51.2c-14.14,0-25.6-11.46-25.6-25.6V179.2c0-14.14,11.46-25.6,25.6-25.6h409.6c14.14,0,25.6,11.46,25.6,25.6V358.4z" />
            </g>
          </g>
          <g>
            <g>
              <path d="M422.4,179.2H320c-7.074,0-12.8,5.726-12.8,12.8s5.726,12.8,12.8,12.8h102.4c7.074,0,12.8-5.726,12.8-12.8 S429.474,179.2,422.4,179.2z" />
            </g>
          </g>
        </g>
      </>
    ),
  },
  nodeRouter: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="1.5" y="8.5" width="13" height="5" rx="1" />
          <path d="M8 8.5V4" />
          <path d="M5 3.8 8 1.8l3 2" />
        </g>
      </>
    ),
  },
  nodeServer: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2.5" y="2" width="11" height="5" rx="1" />
          <rect x="2.5" y="9" width="11" height="5" rx="1" />
          <circle cx="5" cy="4.5" r="0.75" fill="currentColor" stroke="none" />
          <circle cx="5" cy="11.5" r="0.75" fill="currentColor" stroke="none" />
        </g>
      </>
    ),
  },
  nodeSwitch: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="1.5" y="5.5" width="13" height="6" rx="1" />
          <path d="M4.5 5.5v-2M8 5.5v-2M11.5 5.5v-2" />
        </g>
      </>
    ),
  },
  nodeUps: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M12.5 6L8.5 12H14.5L10.5 18M21 13V11M7.7 6H6.2C5.0799 6 4.51984 6 4.09202 6.21799C3.71569 6.40973 3.40973 6.71569 3.21799 7.09202C3 7.51984 3 8.0799 3 9.2V14.8C3 15.9201 3 16.4802 3.21799 16.908C3.40973 17.2843 3.71569 17.5903 4.09202 17.782C4.51984 18 5.0799 18 6.2 18H6.5M16.5 6H16.8C17.9201 6 18.4802 6 18.908 6.21799C19.2843 6.40973 19.5903 6.71569 19.782 7.09202C20 7.51984 20 8.0799 20 9.2V14.8C20 15.9201 20 16.4802 19.782 16.908C19.5903 17.2843 19.2843 17.5903 18.908 17.782C18.4802 18 17.9201 18 16.8 18H15.31"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  paste: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5.6 3.2H4.4A1.2 1.2 0 0 0 3.2 4.4v8.4a1.2 1.2 0 0 0 1.2 1.2h7.2a1.2 1.2 0 0 0 1.2-1.2V4.4a1.2 1.2 0 0 0-1.2-1.2h-1.2" />
          <rect x="5.6" y="1.8" width="4.8" height="2.8" rx="0.8" />
          <path d="M6 9h4" />
          <path d="M6 11.2h2.6" />
        </g>
      </>
    ),
  },
  pause: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 3.6v8.8M10 3.6v8.8" />
        </g>
      </>
    ),
  },
  pencil: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M18 10L21 7L17 3L14 6M18 10L8 20H4V16L14 6M18 10L14 6"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  play: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5.8 3.4 12.4 8l-6.6 4.6z" />
        </g>
      </>
    ),
  },
  plug: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M9 12H15"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 6H16C19.3137 6 22 8.68629 22 12C22 15.3137 19.3137 18 16 18H15"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 18H8C4.68629 18 2 15.3137 2 12C2 8.68629 4.68629 6 8 6H9"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  plus: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M4 12H20M12 4V20"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  power: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M8 8.2547C6.18652 9.51965 5 11.6213 5 14C5 17.866 8.13401 21 12 21C15.866 21 19 17.866 19 14C19 11.6213 17.8135 9.51965 16 8.2547M12 4V12"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  queue: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <path d="M6 4H14" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
          <path d="M6 8H14" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
          <path d="M6 12H14" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
          <path d="M2.5 4H3.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
          <path d="M2.5 8H3.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
          <path d="M2.5 12H3.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        </g>
      </>
    ),
  },
  redo: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M20 9V15M20 15H14M20 15C17.6726 12.9114 15.5171 10.5468 12.2547 10.0878C10.3223 9.81593 8.35395 10.1794 6.64613 11.1234C4.93832 12.0675 3.58359 13.5409 2.78607 15.3218"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  refresh: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M3 3V9M3 9H9M3 9C5.32744 6.91141 7.48287 4.54676 10.7453 4.08779C12.6777 3.81593 14.6461 4.17941 16.3539 5.12343C18.0617 6.06746 19.4164 7.54091 20.2139 9.32177M21 21V15M21 15H15M21 15C18.6725 17.0886 16.5171 19.4532 13.2547 19.9122C11.3223 20.1841 9.35391 19.8206 7.6461 18.8766C5.93829 17.9325 4.58356 16.4591 3.78604 14.6782"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  rewind: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M7.4 4.4 3.2 8l4.2 3.6zM13.4 4.4 9.2 8l4.2 3.6z" />
        </g>
      </>
    ),
  },
  scan: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2.5 5.5v-2a1 1 0 0 1 1-1h2" />
          <path d="M13.5 5.5v-2a1 1 0 0 0-1-1h-2" />
          <path d="M2.5 10.5v2a1 1 0 0 0 1 1h2" />
          <path d="M13.5 10.5v2a1 1 0 0 1-1 1h-2" />
          <path d="M2 8h12" />
        </g>
      </>
    ),
  },
  search: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M20 20L15.8033 15.8033M18 10.5C18 6.35786 14.6421 3 10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18C14.6421 18 18 14.6421 18 10.5Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  skipNext: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3.6 4.4 9.4 8l-5.8 3.6z" />
          <path d="M12.4 4v8" />
        </g>
      </>
    ),
  },
  skipPrev: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3.6 4v8" />
          <path d="M12.4 4.4 6.6 8l5.8 3.6z" />
        </g>
      </>
    ),
  },
  snapshot: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="1.6" y="4.8" width="12.8" height="8.7" rx="1.2" />
          <path d="M5.6 4.8 6.7 2.6h2.6l1.1 2.2" />
          <circle cx="8" cy="9.1" r="2.3" />
        </g>
      </>
    ),
  },
  stop: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="4.2" y="4.2" width="7.6" height="7.6" rx="1.1" />
        </g>
      </>
    ),
  },
  sun: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g fill="none">
          <circle cx="8" cy="8" r="3.1" stroke="currentColor" strokeWidth="1.2" />
          <path
            d="M8 1.5V3M8 13V14.5M1.5 8H3M13 8H14.5M3.12 3.12L4.32 4.32M11.68 4.32L12.88 3.12M4.32 11.68L3.12 12.88M11.68 11.68L12.88 12.88"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  transport: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2.4 5.6h11.2M11.2 3.2l2.4 2.4-2.4 2.4" />
          <path d="M13.6 10.4H2.4M4.8 8l-2.4 2.4L4.8 12.8" />
        </g>
      </>
    ),
  },
  trash: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M10 10V16M14 10V16M18 6V18C18 19.1046 17.1046 20 16 20H8C6.89543 20 6 19.1046 6 18V6M4 6H20M15 6V5C15 3.89543 14.1046 3 13 3H11C9.89543 3 9 3.89543 9 5V6"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  undo: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M4 9V15M4 15H10M4 15C6.32744 12.9114 8.48287 10.5468 11.7453 10.0878C13.6777 9.81593 15.6461 10.1794 17.3539 11.1234C19.0617 12.0675 20.4164 13.5409 21.2139 15.3218"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  upload: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M20 13V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18L4 13M16 8L12 4M12 4L8 8M12 4L12 16"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  userPlus: {
    viewBox: '0 0 24 24',
    body: (
      <>
        <g fill="none">
          <path
            d="M20 8.5V13.5M17.5 11H22.5M8 15H16C18.2091 15 20 16.7909 20 19V21H4V19C4 16.7909 5.79086 15 8 15ZM16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </>
    ),
  },
  volumeOff: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2.6 6.2h2.2L8 3.4v9.2L4.8 9.8H2.6z" />
          <path d="M10.8 6.4 14 9.6M14 6.4l-3.2 3.2" />
        </g>
      </>
    ),
  },
  volume: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2.6 6.2h2.2L8 3.4v9.2L4.8 9.8H2.6z" />
          <path d="M10.6 6.2a2.6 2.6 0 0 1 0 3.6M12.6 4.4a5.2 5.2 0 0 1 0 7.2" />
        </g>
      </>
    ),
  },
  zoomArea: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2.2 5.4V2.2h3.2M13.8 5.4V2.2h-3.2M2.2 10.6v3.2h3.2M13.8 10.6v3.2h-3.2" />
          <circle cx="7.3" cy="7.3" r="2.5" />
          <path d="M9.2 9.2 11.6 11.6" />
        </g>
      </>
    ),
  },
  zoomIn: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="7" cy="7" r="4.2" />
          <path d="M10.1 10.1 13.8 13.8" />
          <path d="M5.2 7h3.6M7 5.2v3.6" />
        </g>
      </>
    ),
  },
  zoomOut: {
    viewBox: '0 0 16 16',
    body: (
      <>
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="7" cy="7" r="4.2" />
          <path d="M10.1 10.1 13.8 13.8" />
          <path d="M5.2 7h3.6" />
        </g>
      </>
    ),
  },
} satisfies Record<string, Glyph>;
